'use client';

import React from 'react';
import { Layout } from '@/components/layout/Layout';
import { useTranslation } from 'react-i18next';
import Link from 'next/link';

function MultilineText({ text }: { text: string }) {
  const lines = text.split('\n');
  return (
    <>
      {lines.map((line, i) => (
        <React.Fragment key={i}>
          {line}
          {i < lines.length - 1 && <br />}
        </React.Fragment>
      ))}
    </>
  );
}

export default function Privacy() {
  const { t } = useTranslation();

  return (
    <Layout>
      <section className="py-16 md:py-24">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">{t('pageContent.privacy.title')}</h1>
            <p className="text-sm text-gray-500 mb-8">{t('pageContent.privacy.lastUpdated')}</p>

            <div className="prose prose-lg max-w-none">
              <h2>{t('pageContent.privacy.sections.intro.title')}</h2>
              <p>{t('pageContent.privacy.sections.intro.content')}</p>

              <h2>{t('pageContent.privacy.sections.controller.title')}</h2>
              <p><MultilineText text={t('pageContent.privacy.sections.controller.content')} /></p>

              <h2>{t('pageContent.privacy.sections.dataCollection.title')}</h2>
              <p>{t('pageContent.privacy.sections.dataCollection.content')}</p>

              <h2>{t('pageContent.privacy.sections.lawfulBasis.title')}</h2>
              <p><MultilineText text={t('pageContent.privacy.sections.lawfulBasis.content')} /></p>

              <h2>{t('pageContent.privacy.sections.dataUse.title')}</h2>
              <p>{t('pageContent.privacy.sections.dataUse.content')}</p>

              {/* GDPR Art. 14 notice to investors. SendVC is a controller for the
                  investor database regardless of who sends the outreach — the data
                  was not collected from the investors themselves, so this notice
                  is the obligation that does not transfer to the founder. */}
              <h2>{t('pageContent.privacy.sections.investorData.title')}</h2>
              <p><MultilineText text={t('pageContent.privacy.sections.investorData.content')} /></p>

              <h2>{t('pageContent.privacy.sections.retention.title')}</h2>
              <p><MultilineText text={t('pageContent.privacy.sections.retention.content')} /></p>

              <h2>{t('pageContent.privacy.sections.processors.title')}</h2>
              <p><MultilineText text={t('pageContent.privacy.sections.processors.content')} /></p>

              <h2>{t('pageContent.privacy.sections.internationalTransfers.title')}</h2>
              <p><MultilineText text={t('pageContent.privacy.sections.internationalTransfers.content')} /></p>

              <h2>{t('pageContent.privacy.sections.dataSecurity.title')}</h2>
              <p>{t('pageContent.privacy.sections.dataSecurity.content')}</p>

              <h2>{t('pageContent.privacy.sections.rights.title')}</h2>
              <p><MultilineText text={t('pageContent.privacy.sections.rights.content')} /></p>

              <h2>{t('pageContent.privacy.sections.cookies.title')}</h2>
              <p>{t('pageContent.privacy.sections.cookies.content')}</p>
              <p>
                <Link href="/cookies" className="text-primary-600 hover:text-primary-700">{t('pages.cookies')}</Link>
              </p>

              <h2>{t('pageContent.privacy.sections.contact.title')}</h2>
              <p>{t('pageContent.privacy.sections.contact.content')}</p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
